export default {
  test: '中文',
  device: '设备信息',
  personal: '个人信息',
  describeLocation: '请描述故障现象',
  ClickDescription: '点击图标添加相应描述',
  voice: '语音',
  video: '视频',
  text: '文字',
  clickAttachment: '点击上传附件',
  uploadFiles: '上传文件',
  Supports: '支持扩展名： .zip .doc .docx .pdf .jpg .txt...',
  PreviewInformation: '预览报修信息',
  PleaseContent: '请输入内容',
  submit: '提交',
  leaveMessage: '留言',
  SN: '出厂编号',
  productLine: '产品线',
  productModel: '型  号',
  hospital: '所属医院',
  address: '所属地址',
  department: '所属科室',
  position: '职位',
  name: '姓名',
  contactWay: '联系方式',
  stopRecording: '停止录音',
  startRecording: '开始录音',
  equipment: '报修内容',
  describe: '描述',
  confirmRepair: '提交报修',
  repairTime: '报修时间',
  submitRepair: '提交报修',
  repairReport: '确定要提交本次报修吗?',
  OnceSubmitted: '一经提交将有专业人员上门维修',
  score: '请评分',
  notScored: '以下是开放问题，不计分',
  productsServices: '您对东软医疗的产品和服务还有其他的意见和建议吗',
  suggestions: '请输入意见和建议',
  maintenanceState: '维修状态',
  chooseYear: '选择年份',
  search: '搜索',
  maintenanceMan: '维修工程师',
  ViewDetailed: '查看详细',
  repairService: '故障报修',
  repairSchedule: '维修进度',
  MaintenanceRecord: '维修记录',
  MaintenanceEvaluation: '维修评价',
  service: '客服咨询',
  quickLogin: '手机号快捷登录',
  verificationCode: '验证码',
  gain: '获取',
  login: '立即登录',
  cellPhone: '手机号码',
  signUp: '立即注册',
  enterNumber: '请输入手机号',
  ResponsibleEquipment: '负责设备',
  selectionTime: '选择时间',
  remainEvaluated: '已完成(待评价)',
  serialNumber: '报修单号',
  compile: '编辑',
  addEquipments: '添加设备',
  save: '保存',
  modifySuccessfully: '修改成功',
  logOut: '退出登录',
  picture: '图片'
}
